<template>
  <section class="container"></section>
</template>

<script>
export default {
  name: 'Whistle',

  data() {
    return {
      ps: [],
      mic: null,
      threshold: 0.15,
      colors: ['#DDDDDF', '#FADF63', '#FFE3DC', '#FFDDA1'],
    };
  },

  created() {
    // Promise.all([
    //   import('p5'),
    //   import('p5/lib/addons/p5.dom'),
    //   import('p5/lib/addons/p5.sound'),
    // ]).then((p5) => {
    //   const sketch = function(p) {
    //     p.x = 100;
    //     p.y = 100;

    //     p.setup = function() {
    //       p.createCanvas(200, 200);
    //       p.background(51);
    //     }

    //     p.draw = function() {
    //       p.x = p.x + p.random(-10, 10);
    //       p.y = p.y + p.random(-10, 10);
    //     }
    //   }

    //   console.log('p5: ', p5.prototype);
    //   // this.myp5 = p5(sketch.bind(this));
    // });
  },

  methods: {
    // setup(p5) {
    //   createCanvas(window.innerWidth, window.innerHeight);
    //   this.ps = new p5.ParticleSystem(createVector(window.innerWidth
    // / 2, window.innerHeight / 2));
    //   this.mic = new p5.AudioIn();
    //   this.mic.start();
    // },

    // draw() {
    //   background("#000000");
    //   const micLevel = mic.getLevel();
    //   if(micLevel > threshold) for(let i=0; i<30; i++) this.ps.addParticle();
    //   this.ps.run();
    // },

  //   Particle(pos) {
  //     this.pos = pos.copy();
  //     this.col=random(colors);
  //     this.size=random(5,30);
  //     this.fill=random([0,1]);
  //     this.velocity = createVector(0, 0);
  //     this.acceleration = createVector(10*random(-1,1), 10*random(-1,1));
  //     this.offset = createVector(random(2000,10000), random(2000,10000));
  //     // this.f=this.acceleration.copy();
  //     // this.f.normalize();
  //     // this.f.mult(-.1);
  //     // console.log("a: "+this.acceleration);
  //     // console.log("f: "+this.f);


  //     this.update = () => {
  //       this.velocity.add(this.acceleration);
  //       this.pos.add(this.velocity);
  //       this.pos.add(createVector(10*(noise(this.offset.x)-.5),10*(noise(this.offset.y)-.5)));
  //       this.offset.x = this.offset.x + 0.01;
  //       this.offset.y = this.offset.y + 0.01;
  //       // var n = noise(xoff) * width;
  //       this.size=this.size*.95;
  //       this.acceleration.mult(0);
  //       if(this.velocity.mag() > 1) this.velocity.mult(.95);
  //       // this.acceleration.add(this.f);
  //     }

  //     this.isDead = () => {
  //       if(this.size<1) return true;
  //       else return false;
  //     }

  //     this.render = () => {
  //       if(this.fill==1) { noStroke(); fill(this.col) }
  //       else { noFill(); stroke(this.col); }
  //       ellipse (this.pos.x, this.pos.y, this.size, this.size);
  //     }
  //   },

  //   ParticleSystem(pos) {
  //     this.origin = pos.copy();
  //     this.particles = [];

  //     this.addParticle = function addParticle() {
  //         this.particles.push(new Particle(this.origin));
  //     };

  //     this.run = () => {
  //       for (var i = this.particles.length-1; i >= 0; i--) {
  //         var p = this.particles[i];
  //         p.update();
  //         p.render();
  //         if (p.isDead()) {
  //           this.particles.splice(i, 1);
  //         }
  //       }
  //     };
  //   }
  },
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/Whistle.vue